import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationService } from '@/lib/services/notification.service';
import { i18n } from '@/shared/i18n';
import { logger } from '@/lib/utils/logger';
import { deleteExternalTool } from '../api';
import { EXTERNAL_TOOLS_QUERY_KEY } from './queryKeys';

export const useDeleteExternalTool = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, workspaceId }: { id: string; workspaceId?: string }) =>
      deleteExternalTool(id, workspaceId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [EXTERNAL_TOOLS_QUERY_KEY] });
      notificationService.showSuccess(
        i18n.t('admin:externalTool.useDeleteExternalTool.externalToolDeleted'),
      );
    },
    onError: (error) => {
      notificationService.showError(
        i18n.t('admin:externalTool.useDeleteExternalTool.failedToDeleteExternalTool'),
      );
      logger.error('Failed to delete external tool:', error);
    },
  });
};
